<template>
    <div class="app-container">
        <el-skeleton v-if="loadingFlag" :rows="3" animated />
        <div v-else class="form-shell">
            <el-form ref="form" :model="form" label-width="160px">
                <el-form-item label="赠送一次抽奖签到天数" prop="days">
                    <el-input type="number" v-model="form.days"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm" :loading="btnLoading">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import { getSet, modifySet } from '@/api/common.js'
export default {
    data: () => ({
        rules: {
            days: [
                { required: true, message: "不能为空", trigger: "blur" },
                {
                    validator: (rules, value, cb) => {
                        if (value < 0) return cb(new Error('不能小于0'))
                        else if (value % 1) return cb(new Error('请输入整数'))
                        cb()
                    }
                }
            ]
        },
        form: {
            days: '',
        },
        loadingFlag: true,
        btnLoading: false
    }),
    beforeMount() {
        this.getData()
    },
    methods: {
        async getData() {
            try {
                let res = await getSet({
                    prefix: "sign.draw",
                    system_logs_content: "基础管理-其它参数设置"
                })
                console.log(res)
                this.form.days = res.data.data[0].value || ''
                this.loadingFlag = false
            } catch (err) {
                console.log('失败', err)
            }
        },
        async submitForm() {
            try {
                this.btnLoading = true
                await modifySet({
                    "sign.draw": {
                        value: this.form.days
                    }
                })
                this.$message.success("设置成功")
                this.btnLoading = false
                this.getData()
            } catch (err) {
                console.log('失败', err)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.form-shell {
    max-width: 512px;
}
</style>